import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Field, change } from 'redux-form';
import { renderSearchJob } from '@app/src/common/SearchJob';
import { FieldForm } from '@app/src/common/FieldForm';
import * as validate from '@app/src/utils/validations';
import {
  clearJobSelected,
  setJobSelected,
  fetchJob,
  fetchJobTop,
  clearJobData
} from '@app/src/views/StepOne/form';
import { isClientEnv } from '@app/src/utils/validations';
import { COLORS } from '@app/src/ui';

const isClient = isClientEnv();
const BREAKPOINT = 768;

interface Props {
  operationId: number;
}

export const TitleJob: React.FC<Props> = ({ operationId }) => {
  const dispatch = useDispatch();
  const jobSelected = useSelector(state => state.job.selected);
  const print = useSelector(state => state.print.general);
  const printTitle = useSelector(state => state.print.general.title);
  const printEmployment = useSelector(state => state.print.general.employment);
  const jobs = useSelector(state => state.job.data);
  const jobsTop = useSelector(state => state.jobTop.data);
  const message = useSelector(state => state.job.message);
  const isLoading = useSelector(state => state.job.isFetching);
  const isLoadingTop = useSelector(state => state.jobTop.isFetching);
  const lastWordFound = useSelector(state => state.job.lastWordFound)

  useEffect(() => {
    if (isClient && window.innerWidth < BREAKPOINT) {
      dispatch(fetchJobTop());
    }
  }, []);

  useEffect(() => {
    if (printTitle) {
      dispatch(change('stepOne', 'title', printTitle));
      dispatch(change('stepOne', 'employment', printEmployment));
      dispatch(setJobSelected(printTitle));
    }
  }, [printTitle]);

  useEffect(() => {
    if (print.operation !== operationId) {
      dispatch(clearJobSelected())
      dispatch(change('stepOne', 'title', ''));
      dispatch(change('stepOne', 'employment', null));
    }
  }, [operationId]);

  const handleChangeInputSearch = (inputValue) => {
    dispatch(fetchJob(inputValue));
  };

  const handleChangeSearchJob = (data) => {
    if (data) {
      const { name, id } = data;
      dispatch(change('stepOne', 'title', name));
      dispatch(change('stepOne', 'employment', id));
      dispatch(setJobSelected(name));
    }
  };

  const handleClickClose = () => {
    dispatch(clearJobData());
    dispatch(clearJobSelected());
    dispatch(change('stepOne', 'title', ''));
    dispatch(change('stepOne', 'employment', null));
  };

  const handleClickOpenModal = () => {
    if (jobsTop && jobsTop.length === 0) {
      dispatch(fetchJobTop());
    }
  };

  const handleBlurSearchJob = () => {
    if (!jobSelected) {
      dispatch(change('stepOne', 'employment', null));
      dispatch(change('stepOne', 'title', ''))
    }
  };

  return(
      <FieldForm label="Título de la publicación">
        <Field
            name="title"
            component={renderSearchJob}
            dataList={(jobs && jobs.length === 0) ? jobsTop : jobs}
            handleChange={handleChangeSearchJob}
            handleClickClose={handleClickClose}
            handleChangeInput={handleChangeInputSearch}
            handleClickOpenModal={handleClickOpenModal}
            handleBlur={handleBlurSearchJob}
            isLoading={isLoading || isLoadingTop}
            placeholder="Ej. Ingeniero civil"
            activeColor={COLORS.BLUE}
            defaultJob={jobSelected}
            validate={[validate.required]}
            message={message}
            isLoadingModal={isLoadingTop}
            minCharForSearch={3}
            lastWordFound={lastWordFound}
      />
      </FieldForm>
)};
